// extracted by mini-css-extract-plugin
export default {"container":"EditExamReviewPage_container__-is84"};